import React, { Component } from 'react';
import PropTypes from 'prop-types'
import {
  Container, Col, Form, Spinner,
  FormGroup, Label, Input,
  Button, FormText, FormFeedback, CustomInput,
  Row, Nav, NavItem, NavLink
} from 'reactstrap';

import makeAnimated from 'react-select/animated';

import Results from './components/Results';

import './App.css';

import { topCounties, texasCounties } from './data/counties'
import { texasPrecincts } from './data/precincts'
import { stateAbbrev } from './data/stateAbbrev'

import _ from 'lodash';

export default class App extends Component {
  constructor(props) {
    super(props);

    this.init = {
      'firstName': null,
      'middleName': null,
      'lastName': null,
      'email': null,
      'phone': null,
      'address': null,
      'addressLine2': null,
      'city': null,
      'county': null,
      'region': null,
      'zip': null,
      'dob': null,
      'isSubmitted': false,
    };

    this.state = {
      validate: {
        emailState: '',
      },
      ...this.init
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputOptsChange = this.handleInputOptsChange.bind(this);
  }

  componentDidMount() {
   
  }

  validateEmail(e) {
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const { validate } = this.state
    if (emailRex.test(e.target.value)) {
      validate.emailState = 'has-success'
    } else {
      validate.emailState = 'has-danger'
    }
    this.setState({ validate })
  }

  validateFirstName(e) {
    const firstNameRex = /^[a-zA-Z ]{1,30}$/;
    const { validate } = this.state
    if (firstNameRex.test(e.target.value)) {
      validate.firstNameState = 'has-success'
    } else {
      validate.firstNameState = 'has-danger'
    }
    this.setState({ validate })
  }

  validateLastName(e) {
    const lastNameRex = /^[a-zA-Z ]{2,30}$/;
    const { validate } = this.state
    if (lastNameRex.test(e.target.value)) {
      validate.lastNameState = 'has-success'
    } else {
      validate.lastNameState = 'has-danger'
    }
    this.setState({ validate })
  }

  validatePhone(e) {
    const phoneRex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    const { validate } = this.state
    if (phoneRex.test(e.target.value)) {
      validate.phoneState = 'has-success'
    } else {
      validate.phoneState = 'has-danger'
    }
    this.setState({ validate })
  }

  validateZip(e) {
    const zipRex = /^\d{5}(-\d{4})?(?!-)$/;
    const { validate } = this.state
    if (zipRex.test(e.target.value)) {
      validate.zipState = 'has-success'
    } else {
      validate.zipState = 'has-danger'
    }
    this.setState({ validate })
  }

  validateDate(e) {
    const dateRex = /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/;
    // const dateRex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    const { validate } = this.state
    if (dateRex.test(e.target.value)) {
      validate.dateState = 'has-success'
    } else {
      validate.dateState = 'has-danger'
    }
    this.setState({ validate })
  }

  validateResAddress(e) {
    const addrRex = /^[#.0-9a-zA-Z\s,-]+$/;
    const { validate } = this.state
    if (addrRex.test(e.target.value)) {
      validate.addrState = 'has-success'
    } else {
      validate.addrState = 'has-danger'
    }
    this.setState({ validate })
  }

  validateCity(e) {
    const cityRex = /^[a-zA-Z]+(?:(?:\\s+|-)[a-zA-Z]+)*$/;
    const { validate } = this.state
    if (cityRex.test(e.target.value)) {
      validate.cityState = 'has-success'
    } else {
      validate.cityState = 'has-danger'
    }
    this.setState({ validate })
  }

  agreed = () => {
    this.setState({
      isAffiliated: true
    })
  }

  handleChange = async (event) => {
    const { target } = event;
    // const value = target.type === 'checkbox' ? target.checked : target.value;

    await this.setState({
      [target.id]: target.value,

    });
    // console.log('Target!', target.value)
  }

  handleSelectChange = (newValue, actionMeta) => {
    console.group('Tag Select value changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    this.setState({
      value: newValue
    });
  };

  handleSupporterSelectChange = (newValue, actionMeta) => {
    console.group('Supporter ID Select value changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    this.setState({
      surveyQuestionId: newValue
    });
  };

  handleInputOptsChange = (newValue, actionMeta) => {
    console.group('Input Options Select value changed');
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    this.setState({
      inputOptionValue: newValue
    });
  };


  getCountyOptions() {
    const topCountySelect = topCounties.map(county => {
      return (
        <option key={county}>{county}</option>
      )
    })

    const texasCountySelect = texasCounties.map(county => {
      return (
        <option key={county}>{county}</option>
      )
    })
    return (
      <CustomInput type="select" id="county" name="county" onChange={this.handleChange}>
        <option value="">Select</option>
        {topCountySelect}
        {texasCountySelect}
      </CustomInput>
    )
  }

  getPrecinctOptions() {
    const texasPrecinctSelect = texasPrecincts.map(precinct => {
      return (
        <option key={precinct}>{precinct}</option>
      )
    })
    return (
      <CustomInput type="select" id="county" name="county" onChange={this.handleChange}>
        <option value="">Select</option>
        {texasPrecinctSelect}
      </CustomInput>
    )
  }


  getStateOptions() {
    const stateSelect = stateAbbrev.map(state => {
      return (
        <option key={state}>{state}</option>
      )
    })

    return (
      <CustomInput type="select" id="region" name="state" onChange={this.handleChange}>
        <option value=""></option>
        {stateSelect}
      </CustomInput>
    )
  }

  getBody() {
    let body = _.cloneDeep(this.state);

    delete body.validate;
    delete body.isLoading;
    delete body.isSubmitted;
    delete body.isAffiliated;

    // Convert all boolean-type values to actual boolean
    for (const key in body) {
      if (this.init.hasOwnProperty(key)) {
        if (this.init[key] === false || this.init[key] === true) {
          body[key] = body[key] === 'true';
        }
      }
    }

    body.value = (body.value || []).map(v => v.value).join(',');
    return JSON.stringify(body);
  }

  submitForm(e) {
    e.preventDefault();
    let base64 = require('base-64');

    this.setState({ isLoading: true })

    let username = JSON.stringify(process.env.REACT_APP_USERNAME);
    let password = JSON.stringify(process.env.REACT_APP_PASSWORD);

    let headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Origin', 'http://localhost:3000');

    headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));

    const body = this.getBody();
    console.log('this.state: ', this.state)

   // POST to VAN api endpoints hangs:
   fetch('https://van-buddy-server.appspot.com/api/add-myc-email', {
   // fetch('http://localhost:3001/api/add-van-email-sandbox', {
        method: 'POST',
        mode: 'cors',
        headers: headers,
        redirect: 'follow',
        body: JSON.stringify(this.state)
      }).then((response) => {
        if (response.ok) {
          // console.log('VAN API RESPONSE: ', response.status)
          // console.log('response: ', response)
          
          this.setState({isSubmitted: true, isLoading: false})

          // return response.json(); 
          // console.log(response.clone().json())
          // response.json() is resolving its promise. It waits for the body to load
          // return response.json()
          return response.text()
        } else {
          throw Error(`Request rejected with status ${response.status}`);
        }
      }).catch(console.error)
  }

  render() {
    const animatedComponents = makeAnimated();

    return (
      <div className="outerDiv">
      <Container className="App">     
        {!this.state.isSubmitted && !this.state.isLoading && (

          <Form className="form" id="julie_app" onSubmit={(e) => this.submitForm(e)}>
           {/*<div className="requiredMsg">  
              <FormText color="muted" aria-label="Required field">
                 * = Required field.
              </FormText>
            </div>*/}
          <div className="genericContainer">
           
            <Row form>
              <Col md={6}>

                <FormGroup>
                  <Label for="firstName"><span className="emailForm emailFormLabel">First name<span className="requiredFlag">*</span></span></Label>
                  <Input 
                    required
                    type="text" 
                    name="firstName" 
                    id="firstName" 
                    placeholder="First name"
                    valid={this.state.validate.firstNameState === 'has-success'}
                    invalid={this.state.validate.firstNameState === 'has-danger'} 
                    onChange={(e) => {
                      this.handleChange(e)
                      this.validateFirstName(e)
                    }} />
                  <FormFeedback valid>
                  </FormFeedback>
                  <FormFeedback>
                    Please provide your first name.
                   </FormFeedback>
                </FormGroup>
              </Col>
              
              <Col md={6}>
                <FormGroup>
                  <Label for="lastName"><span className="emailForm emailFormLabel">Last name<span className="requiredFlag">*</span></span></Label>
                  <Input 
                    required
                    type="text" 
                    name="lastName" 
                    id="lastName" 
                    placeholder="Last name"
                    valid={this.state.validate.lastNameState === 'has-success'}
                    invalid={this.state.validate.lastNameState === 'has-danger'}  
                    onChange={(e) => {
                      this.handleChange(e)
                      this.validateLastName(e)
                    }} />
                  <FormFeedback valid>
                  </FormFeedback>
                  <FormFeedback>
                    Please provide your last name.
                   </FormFeedback>
                </FormGroup>
              </Col>
            </Row>

            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="email"><span className="emailForm emailFormLabel">Email<span className="requiredFlag">*</span></span></Label>
                  <Input
                    required
                    type="email"
                    name="email"
                    id="email"
                    placeholder="you@yourdomain.com"
                    valid={this.state.validate.emailState === 'has-success'}
                    invalid={this.state.validate.emailState === 'has-danger'}
                    onChange={(e) => {
                      this.handleChange(e)
                      this.validateEmail(e)
                    }}
                  />
                  <FormFeedback valid>
                  </FormFeedback>
                  <FormFeedback>
                    Let's make sure that's a correct email.
                   </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="zip"><span className="emailForm emailFormLabel">Zip<span className="requiredFlag">*</span></span></Label>
                  <Input
                    required
                    type="text"
                    name="zip"
                    id="zip"
                    placeholder="Your 5 digit zip code"
                    valid={this.state.validate.zipState === 'has-success'}
                    invalid={this.state.validate.zipState === 'has-danger'}
                    onChange={(e) => {
                      this.handleChange(e)
                      this.validateZip(e)
                    }}
                  />
                  <FormFeedback valid>
                    Looks good!
                  </FormFeedback>
                  <FormFeedback>
                    Please enter a valid ZIP Code.
                  </FormFeedback>
                </FormGroup>
              </Col>
              
            </Row>
            <Button className="joSubmit" color="primary" size="lg" block><span className="vbFormHead">Submit</span></Button>
        </div>
      </Form>
       )
      }

        {this.state.isLoading && (
          <React.Fragment>
            <div className="loaderWrapper">
              <div>
                <h3>Saving your response...</h3>
              </div>

              <Spinner
                className="loading"
                color="primary"
                style={{ width: '6rem', height: '6rem' }}
              />
            </div>
          </React.Fragment>
        )
        }


        <div>
          {this.state.isSubmitted && <Results />}
        </div>
       
      </Container>
      </div>
    );

  
  }
}


Input.propTypes = {
  children: PropTypes.node,
  // type can be things like text, password, (typical input types) as well as select and textarea, providing children as you normally would to those.
  type: PropTypes.string,
  size: PropTypes.string,
  bsSize: PropTypes.string,
  // state: deprecated(PropTypes.string, 'Please use the prop "valid"'),
  valid: PropTypes.bool, // applied the is-valid class when true, does nothing when false
  invalid: PropTypes.bool, // applied the is-invalid class when true, does nothing when false
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // ref will only get you a reference to the Input component, use innerRef to get a reference to the DOM input (for things like focus management).
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // static: deprecated(PropTypes.bool, 'Please use the prop "plaintext"'),
  plaintext: PropTypes.bool,
  addon: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object,
};

CustomInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.string.isRequired, // radio, checkbox, select, range, switch, file.
  label: PropTypes.string, // used for checkbox and radios
  inline: PropTypes.bool,
  valid: PropTypes.bool, // applied the is-valid class when true, does nothing when false
  invalid: PropTypes.bool, // applied the is-invalid class when true, does nothing when false
  bsSize: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.func]), // for type="select"
  // innerRef would be referenced to select node or input DOM node, depends on type property
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func,
  ])
};

Form.propTypes = {
  children: PropTypes.node,
  inline: PropTypes.bool,
  // Pass in a Component to override default element
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]), // default: 'form'
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object,
};

FormFeedback.propTypes = {
  children: PropTypes.node,
  // Pass in a Component to override default element
  tag: PropTypes.string, // default: 'div'
  className: PropTypes.string,
  cssModule: PropTypes.object,
  valid: PropTypes.bool, // default: undefined
  tooltip: PropTypes.bool
};

FormGroup.propTypes = {
  children: PropTypes.node,
  // Applied the row class when true, does nothing when false
  row: PropTypes.bool,
  // Applied the form-check class when true, form-group when false
  check: PropTypes.bool,
  inline: PropTypes.bool,
  // Applied the disabled class when the check and disabled props are true, does nothing when false
  disabled: PropTypes.bool,
  // Pass in a Component to override default element
  tag: PropTypes.string, // default: 'div'
  className: PropTypes.string,
  cssModule: PropTypes.object,
};

FormText.propTypes = {
  children: PropTypes.node,
  inline: PropTypes.bool,
  // Pass in a Component to override default element
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]), // default: 'small'
  color: PropTypes.string, // default: 'muted'
  className: PropTypes.string,
  cssModule: PropTypes.object,
};


Nav.propTypes = {
  tabs: PropTypes.bool,
  pills: PropTypes.bool,
  card: PropTypes.bool,
  justified: PropTypes.bool,
  fill: PropTypes.bool,
  vertical: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  horizontal: PropTypes.string,
  navbar: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
  // pass in custom element to use
}

NavItem.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  active: PropTypes.bool,
  // pass in custom element to use
}

NavLink.propTypes = {
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  // pass in custom element to use
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // ref will only get you a reference to the NavLink component, use innerRef to get a reference to the DOM element (for things like focus management).
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
}
